import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Pictogram } from "../components/brand/Pictogram";
import { Logo } from "../components/brand/Logo";
import { CtaBand } from "../components/CtaBand";
import { THEMES, IMG } from "../data/content";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero eyebrow="Services" title="Confiez-nous tout ou partie de votre système d'information." lead="De l'infrastructure au support utilisateurs, nous exploitons, supervisons et faisons évoluer votre SI. Vous choisissez le périmètre : un service, une activité de support, ou l'ensemble." />
      <section className="mx-auto max-w-7xl px-5 lg:px-8 py-20 lg:py-28 space-y-6">
        {THEMES.map((t, i) => (
          <Reveal key={t.slug}>
            <Link to={`/services/${t.slug}`} data-testid={`services-item-${t.slug}`} className="group grid md:grid-cols-12 bg-white border border-ink/10 overflow-hidden hover:shadow-xl transition-shadow">
              <div className={`md:col-span-5 relative aspect-[16/10] md:aspect-auto overflow-hidden ${i % 2 ? "md:order-2" : ""}`}>
                <img src={IMG[t.image]} alt={t.name} className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-ink/55" />
                <div className="absolute left-6 bottom-6"><Logo theme={t.color} label={t.name} /></div>
              </div>
              <div className="md:col-span-7 p-8 lg:p-12" style={{ borderTop: `4px solid ${t.color}` }}>
                <Pictogram name={t.icon} color={t.color} size={48} />
                <h2 className="mt-5 font-display text-2xl lg:text-3xl font-extrabold">{t.name}</h2>
                <p className="mt-3 text-ink/65 max-w-lg">{t.tagline}</p>
                <ul className="mt-6 grid sm:grid-cols-2 gap-2.5">
                  {t.offers.map(([o]) => (
                    <li key={o} className="text-sm flex gap-2"><Check size={16} style={{ color: t.color }} className="shrink-0 mt-0.5" />{o}</li>
                  ))}
                </ul>
                <span className="mt-8 inline-flex items-center gap-2 font-semibold text-sm" style={{ color: t.color }}>Voir le détail <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" /></span>
              </div>
            </Link>
          </Reveal>
        ))}
      </section>
      <CtaBand />
    </div>
  );
}
